import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import SEO from "../common/SEO";
import AboutThree from "../component/about/AboutThree";
import ClientSlider from "../component/client/ClientSlider";
import CounterUpOne from "../component/counterup/CounterUpOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";

const WhoWeAre = () => {
  return (
    <>
      <SEO title="Who We Are" />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne
          subtitle="Our story, Our Values"
          title="Who We Are"
          page="Who-we-are"
        />
        <div
          className="container "
          style={{
            maxWidth: "800px",
            paddingTop: "70px",
            paddingBottom: "40px",
          }}
        >
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            UCWF: Delivering Excellence in Facilities Management for 19 Years
          </h5>
          <p>
            For over 19 years, UCWF has been a trusted leader in the UAE’s
            facilities management sector, providing comprehensive solutions
            tailored to diverse operational needs. Our commitment to transparent
            communication and collaboration ensures a deep understanding of our
            clients’ specific requirements, allowing us to deliver seamless,
            high-quality facility management services. Whether managing
            large-scale, complex operations or catering to smaller, specialized
            businesses, we offer end-to-end solutions designed to maintain
            facilities at optimal performance levels. Our specialized services
            enable clients to consolidate all their maintenance needs under one
            provider, enhancing efficiency and reducing costs. Through the
            seamless integration of budgeting, communication, and
            accountability, we provide clarity and peace of mind. Additionally,
            our 24/7 emergency response service guarantees that skilled
            engineers are always available to deliver prompt, reliable support.{" "}
          </p>
          <p></p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            Driving Growth and Innovation in Facilities Management{" "}
          </h5>
          <p>
            UCWF’s expansion has been fuelled by entrepreneurial growth,
            strategic partnerships, and key acquisitions. Our expertise spans a
            wide range of essential services, including energy management,
            specialized cleaning, security, electrical system maintenance, and
            large-scale chiller servicing. As an accredited Energy Services
            Company (ESCO), we are committed to sustainability and the adoption
            of cleaner energy solutions. Today, UCWF is recognized as one of the
            leading facilities management providers in the UAE, delivering
            excellence across various sectors, including infrastructure, luxury
            properties, mixed-use developments, retail, education, and more. Our
            expertise extends to Energy Management, Predictive and Preventive
            Maintenance, Strategic Facilities Planning (SFP), as well as
            specialized services in hospitality, cleaning, and security.{" "}
          </p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            Commitment to a Smarter, Sustainable Future{" "}
          </h5>
          <p>
            At UCWF, we align with the UAE’s vision for a smart and sustainable
            future by embracing cutting-edge technologies and adhering to the
            highest international standards. Our mission is to deliver
            exceptional service, ensuring that facilities are not only
            well-maintained but also future-ready. By fostering long-term
            partnerships, we create sustainable solutions that drive progress
            for businesses and communities alike.
          </p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            UCWF Facility Management Services: Where Quality Meets Reliability{" "}
          </h5>
          <p>
            From the outset, our goal has been to revolutionize facilities
            management through innovative, client-centric solutions. Today, UCWF
            is a trusted partner across diverse industries, known for its
            unparalleled expertise and unwavering commitment to excellence.
          </p>
        </div>

        <CounterUpOne />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>

        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />
        <AboutThree />

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default WhoWeAre;
